/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Backtoevents2Inputs */

const en_backtoevents2 = /** @type {(inputs: Backtoevents2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to Events`)
};

const de_backtoevents2 = /** @type {(inputs: Backtoevents2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zu den Events`)
};

/**
* | output |
* | --- |
* | "Back to Events" |
*
* @param {Backtoevents2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const backtoevents2 = /** @type {((inputs?: Backtoevents2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backtoevents2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_backtoevents2(inputs)
	return de_backtoevents2(inputs)
});
export { backtoevents2 as "backToEvents" }